import {IStoreContract} from "@/stores/contract"
import {ContractStatusEnum, ContractSubStatusEnum} from "@/enums"

export const hasAtLeastOneBlockage = (contract: IStoreContract|null) => {
    return isBlocked(contract) || isBlockedCredit(contract) || isBlockedFraud(contract)
}

export const getDisplayId = (contract: IStoreContract|null, useMsisdnAsId = true) => {
    if (!contract) {
        return ''
    }

    if (useMsisdnAsId && contract.msisdn && contract.msisdn !== '') {
        return "0" + contract.msisdn
    }
    if (contract.orderId && contract.orderId !== '') {
        return contract.orderId
    }

    return (contract.contractId && contract.contractId !== '') ? contract.contractId : "#" + contract.id
}

export const isActivationProcess = (contract: IStoreContract|null) => {
    if (!contract || !contract.subStatus) {
        return false
    }
    
    return {
        [ContractSubStatusEnum.ActivationRequested]: true,
        [ContractSubStatusEnum.ActivationExecuted]: true,
        [ContractSubStatusEnum.ActivationFailed]: true,        
        [ContractSubStatusEnum.PortInRequested]: true,
        [ContractSubStatusEnum.PortInExecuted]: true,
        [ContractSubStatusEnum.PortInAccepted]: true,
        [ContractSubStatusEnum.PortInFailed]: true,
    }[contract.subStatus] ?? false
}

export const isActivationRequested = (contract: IStoreContract|null) => {
    if (!contract || !contract.subStatus) {
        return false
    }
    
    return {
        [ContractSubStatusEnum.ActivationRequested]: true,
        [ContractSubStatusEnum.PortInRequested]: true,
    }[contract.subStatus] ?? false
}

export const isActivationFailed = (contract: IStoreContract|null) => {
    if (!contract || !contract.subStatus) {
        return false
    }
    
    return {
        [ContractSubStatusEnum.ActivationFailed]: true,
        [ContractSubStatusEnum.PortInFailed]: true,
    }[contract.subStatus] ?? false
}

export const isCancellable = (contract: IStoreContract|null) => {
    if (!contract) {
        return false
    }

    return {
        [ContractStatusEnum.Activated]: false,
        [ContractStatusEnum.Canceled]: false,
        [ContractStatusEnum.InDelivery]: false
    }[contract.status] ?? true
}

export const isBlocked = (contract: IStoreContract|null) => {
    if (!contract || !contract.subStatus) {
        return false
    }

    return {
        [ContractSubStatusEnum.BlockedGeneral]: true,
    }[contract.subStatus] ?? false
}

export const isBlockedCredit = (contract: IStoreContract|null) => {
    if (!contract || !contract.subStatus) {
        return false
    }

    return {
        [ContractSubStatusEnum.BlockedCredit]: true,
        [ContractSubStatusEnum.BlockedGraydon]: true,
    }[contract.subStatus] ?? false
}

export const isBlockedFraud = (contract: IStoreContract|null) => {
    if (!contract || !contract.subStatus) {
        return false
    }
    
    return {
        [ContractSubStatusEnum.BlockedFraud]: true,
    }[contract.subStatus] ?? false
}

export const isDisplayable = (contract: IStoreContract|null) => {
    if (!contract || !contract.subStatus) {
        return false
    }

    return {
        [ContractStatusEnum.Activated]: true,
        [ContractStatusEnum.Completed]: true,
        [ContractStatusEnum.InDelivery]: true,
        [ContractStatusEnum.InValidation]: true,
        [ContractStatusEnum.Suspended]: true
    }[contract.status] ?? false
}

export const isOrderValidated = (contract: IStoreContract|null) => {
    if (!contract || !contract.subStatus) {
        return false
    }
    
    return (contract.status === ContractStatusEnum.InDelivery && contract.subStatus === ContractSubStatusEnum.OrderValidated)
}

export const isInValidation = (contract: IStoreContract|null) => {
    if (!contract || !contract.status) {
        return false
    }
    
    return (contract.status === ContractStatusEnum.InValidation)
}

export const isSimActivable = (contract: IStoreContract|null) => {
    if (!contract || !contract.subStatus) {
        return false
    }
    
    return (contract.status === ContractStatusEnum.InDelivery && contract.subStatus === ContractSubStatusEnum.SimSent)
}

export const isSimSentIssue = (contract: IStoreContract|null) => {
    if (!contract || !contract.subStatus) {
        return false
    }

    return ({
        [ContractSubStatusEnum.SimDeliveryFailed]: true
    }[contract.subStatus] ?? false) && contract.status === ContractStatusEnum.InDelivery
}

export const isContractActivated = (contract: IStoreContract|null) => {
    if (!contract || !contract.subStatus) {
        return false
    }

    return contract.subStatus == ContractStatusEnum.Activated && contract.status == contract.subStatus
}

export const statusRedirectsToOrderFollow = (contract: IStoreContract|null) => {
    if (!contract || !contract.status) {
        return false 
    }

    return ({
        [ContractStatusEnum.Activated]: false,
        [ContractStatusEnum.Terminated]: false,
        [ContractStatusEnum.Suspended]: false,
    }[contract.status] ?? true)
}
